import Vue from 'vue'
// import './plugins/vuetify'
import App from './App.vue'
import firebase from 'firebase/app'
import router from "./router";
import store from "./store";
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import { CHECK_AUTH } from "./store/actions.type";

Vue.config.productionTip = false

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyD-yOpdT54hcmvLkp8lpkUtoyX7usyhc2s",
  authDomain: "str-hris.firebaseapp.com",
  databaseURL: "https://str-hris.firebaseio.com",
  projectId: "str-hris",
  storageBucket: "str-hris.appspot.com",
  messagingSenderId: "367339217583",
  appId: "1:367339217583:web:078ed6d6041bcdf4"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  if(to.fullPath === '/login') {
    next();
  } else {
    Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
    .catch(() => {
      next('/login')
    })
  }
});

Vue.use(Vuetify, {
  theme: {
    primary: '46A7F1',
    error: '#d75850'
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
